import { render } from "./InfographicsTemplates.vue?vue&type=template&id=029f5c98"
import script from "./InfographicsTemplates.vue?vue&type=script&lang=js"
export * from "./InfographicsTemplates.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__